







































import Vue from 'vue'
import ConfirmDialog from '@/components/elements/ConfirmDialog.vue'
import { ActionInterface, ConfirmationMessage2ElInterface } from '@/config/interfaces'
import { darkColors, lightColors } from '@/config/colors'

export default Vue.extend({
  name: 'ConfirmationMessage2El',

  components: { ConfirmDialog },

  data: () => ({
    showPopup: false
  }),

  computed: {
    hasPopup (): boolean {
      return !!Object.prototype.hasOwnProperty.call(this.$props.templateItemData, 'confirmDialog')
    },
    linkDefaultColor (): string {
      return (this.$vuetify.theme.dark ? darkColors.secondary : lightColors.primary)
    }
  },
  methods: {
    handleActionClick (action: ActionInterface): void {
      if (action.uri !== undefined) {
        this.getView(action.view, action.content || action.uri, null, action.jumpOnCloseUri)
      }
    }
  },
  props: {
    templateItemData: {
      type: Object as () => ConfirmationMessage2ElInterface,
      required: true
    }
  }
})
